import colors from '@lmc/common/constants'
import React from 'react'

const TrashcanIcon = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3771_5180)">
      <path
        d="M13.5 5.33331V14C13.5 14.3536 13.3595 14.6927 13.1095 14.9428C12.8594 15.1928 12.5203 15.3333 12.1667 15.3333H4.83333C4.47971 15.3333 4.14057 15.1928 3.89052 14.9428C3.64048 14.6927 3.5 14.3536 3.5 14V5.33331"
        stroke={colors.white}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 3.33331H15.5"
        stroke={colors.white}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.16675 3.33332V0.666656H10.8334V3.33332"
        stroke={colors.white}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 7.99033L6.5 11.9903"
        stroke={colors.white}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 11.9903L6.5 7.99033"
        stroke={colors.white}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3771_5180">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)

export default TrashcanIcon
